const category = {
  title: '彩票大厅',
  subtitle: '选择您喜欢的彩票玩法，开启幸运之旅',
  allCategories: '全部玩法',
  rulesTitle: '玩法规则',
  oddsTitle: '奖级设置',
  tipsTitle: '购彩贴士',
  howToPlay: '如何购买',
  latestResult: '最新开奖',
  period: '期号',
  drawDate: '开奖日期',
  winningNumbers: '开奖号码',
  noData: '暂无开奖数据',
  buyNow: '立即购买',
  viewHistory: '历史开奖',
};

export default category;